module.exports = __webpack_public_path__ + "img/universal-links.9bcc19c.png";